import TextInput from '@/common/components/base/input/textInput/TextInput';
import MainModal from '@/common/components/base/modal/Modal';
import Typography from '@/common/components/base/typography/Typography';
import useDebounce from '@/common/hooks/useDebounce';
import useInfinityScroll from '@/common/hooks/useInfinityScroll';
import useModal from '@/common/hooks/useModal';
import convertGregorianToShamsi from '@/common/utils/convertGregorianToShamsi';
import { FILE_DETAIL_LINKS } from '@/modules/FileDetail/FileDetailLinks';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';
import SearchIcon from '../../../../common/assets/icons/searchNormalIcon.svg?react';
import NoCaseIcon from '../../assets/icons/noCaseIcon.svg?react';
import { walletFileListQueryOptions } from '../../queries/walletFileList/walletFileListQueryOptions';
import ProjectCard from '../walletCards/ProjectCard';

export default () => {
  const { openModal, open, closeModal } = useModal({});

  return (
    <>
      <Flex
        alignItems={'center'}
        gap={8}
        width={'100%'}
        bgColor={'#e8ebee'}
        borderRadius={8}
        height={36}
        px={12}
        py={2}
        flexShrink={0}
        cursor={'pointer'}
        css={{
          '& svg': { width: '16px', height: '16px' },
          '& svg path': { fill: '#465c73' },
        }}
        onClick={openModal}
      >
        <SearchIcon />
        <Typography lineHeight={'26px'} color={'#465c73'}>
          جستجوی پرونده
        </Typography>
      </Flex>
      <MainModal
        fullHeight
        closeModal={closeModal}
        open={open}
        title="جستجوی پرونده"
      >
        <CaseSearch />
      </MainModal>
    </>
  );
};

function CaseSearch() {
  const form = useForm();
  const navigate = useNavigate();
  const debounce = useDebounce();
  const [searchValue, setSearchValue] = useState('');

  const { data, fetchNextPage } = useInfiniteQuery(
    walletFileListQueryOptions(
      {
        page: 1,
        reference_id: searchValue || undefined,
      },
      !!searchValue,
    ),
  );

  const { observerRefCallback } = useInfinityScroll(fetchNextPage);

  const caseSearchHandler = (value: string) => {
    debounce(() => {
      setSearchValue(value);
    }, 500);
  };

  const totalCount = data?.pages?.[0]?.count ?? 0;

  useEffect(() => {
    form.setFocus('case-search');
  }, []);

  return (
    <Flex gap={16} alignItems="center">
      <FormProvider {...form}>
        <Flex flexDirection={'column'} width={'100%'}>
          <TextInput
            name="case-search"
            placeholder="شماره پرونده"
            onChange={caseSearchHandler}
            noCharInput
          />
          <Flex flexDirection="column" gap={12} mb={56}>
            {data?.pages?.map((page) =>
              page?.results?.map((file) => (
                <Box
                  key={file.id}
                  onClick={() => {
                    navigate(FILE_DETAIL_LINKS.detail(file?.file_id ?? 0));
                  }}
                >
                  <ProjectCard
                    ref={observerRefCallback}
                    amount={file.amount}
                    referenceId={file.reference_id}
                    fileCreatedAt={convertGregorianToShamsi(
                      file.registered_at ?? '2025-01-01',
                    )}
                  />
                </Box>
              )),
            )}
          </Flex>

          {!totalCount && (
            <Flex
              alignItems={'center'}
              justifyContent={'center'}
              flexDirection={'column'}
            >
              <NoCaseIcon />
              <Typography mt={-16} textStyle={'h1'}>
                پرونده‌ای یافت نشد!
              </Typography>
            </Flex>
          )}
        </Flex>
      </FormProvider>
    </Flex>
  );
}
